const keyBoard = {
  namespaced: true,
  state: {
    /**控制价格显示 */
    priceFlage: true,
  },
  mutations: {
    changePriceFlage(state, context) {
      state.priceFlage = context;
    },
  },
  actions: {},
};

export default keyBoard;



// WEBPACK FOOTER //
// ./src/store/keyBoard/keyBoard.ts